import { useEffect, useRef } from "react";
import { Icon } from "../components/Icon.jsx";

export function DriverActionDialog({ title, description, children, actions, onClose, busy = false }) {
  const dialogIdRef = useRef(`driver-dialog-${crypto.randomUUID()}`);
  const onCloseRef = useRef(onClose);
  const busyRef = useRef(busy);
  const closedByHistoryRef = useRef(false);

  useEffect(() => {
    onCloseRef.current = onClose;
    busyRef.current = busy;
  }, [busy, onClose]);

  useEffect(() => {
    const dialogId = dialogIdRef.current;
    const currentState = window.history.state || {};
    window.history.pushState(
      { ...currentState, driverApp: true, driverView: "modal", driverModalId: dialogId },
      "",
      `${window.location.pathname}${window.location.search}`,
    );

    function handlePopState(event) {
      if (event.state?.driverModalId === dialogId) return;
      if (busyRef.current) {
        window.history.pushState(
          { ...(event.state || {}), driverApp: true, driverView: "modal", driverModalId: dialogId },
          "",
          `${window.location.pathname}${window.location.search}`,
        );
        return;
      }
      closedByHistoryRef.current = true;
      onCloseRef.current();
    }

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
      if (!closedByHistoryRef.current && window.history.state?.driverModalId === dialogId) {
        window.history.back();
      }
    };
  }, []);

  useEffect(() => {
    function handleKey(event) {
      if (event.key === "Escape" && !busyRef.current) onCloseRef.current();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <div className="driver-dialog-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget && !busy) onClose();
    }}>
      <section aria-modal="true" className="driver-dialog" role="dialog">
        <header>
          <div>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <button aria-label="Tutup" disabled={busy} onClick={onClose} type="button">
            <Icon name="close" size={19} />
          </button>
        </header>
        <div className="driver-dialog__body">{children}</div>
        <footer>{actions}</footer>
      </section>
    </div>
  );
}
